import { render, staticRenderFns } from "./FavouriteProducts.vue?vue&type=template&id=642c6a40"
import script from "./FavouriteProducts.vue?vue&type=script&lang=js"
export * from "./FavouriteProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports